
import Vue from "vue";
import TextField from "@/components/molecules/TextField.vue";
import SignUpConfirmCode from "@/components/organisms/SignUpConfirmCode.vue";
import { Auth } from "aws-amplify";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField, SignUpConfirmCode },
  props: {
    propEmail: {
      type: String,
      default: "",
    },
    propMessage: {
      type: String,
      default: "",
    },
  },
  name: "signup",
  created() {
    const { propEmail, propMessage } = this;

    this.email = propEmail;
    this.message = propMessage;
  },
  data() {
    return {
      confirmCode: "",
      email: "",
      message: "",
      errorMessage: "",
      inputConfirmCode: false,
    };
  },
  methods: {
    async complete() {
      const { email } = this;
      this.$router.push({ name: "signIn", params: { email } });
    },
    async resend() {
      const { email } = this;
      if (!email) return;

      // リクエスト開始時にメッセージをクリア
      this.message = "";
      this.errorMessage = "";

      try {
        await Auth.resendSignUp(email);
        this.message = this.$t('resendConfirmCodePage.validation.codeSent') as string;
        this.confirmCode = "";
        this.inputConfirmCode = true;
      } catch (err) {
        if (err.code === "InvalidParameterException") {
          this.errorMessage = this.$t('resendConfirmCodePage.validation.userAlreadyConfirmed') as string;
        } else if (err.code === "UserNotFoundException") {
          this.errorMessage = this.$t('resendConfirmCodePage.validation.userNotFound') as string;
        } else if (err.code === "LimitExceededException") {
          this.errorMessage = this.$t('resendConfirmCodePage.validation.limitExceeded') as string;
        } else {
          this.errorMessage = `${this.$t('resendConfirmCodePage.validation.genericError')} ${JSON.stringify(err)}`;
        }
      }
    },
  },
});
